import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayersBehind: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconLayersBehind"><Path d="M4.5 3C4.22386 3 4 3.22386 4 3.5C4 3.77614 4.22386 4 4.5 4H19.5C19.7761 4 20 3.77614 20 3.5C20 3.22386 19.7761 3 19.5 3H4.5Z" fill="currentColor"/><Path d="M4.5 6C3.11929 6 2 7.11929 2 8.5V17.5C2 18.8807 3.11929 20 4.5 20H19.5C20.8807 20 22 18.8807 22 17.5V8.5C22 7.11929 20.8807 6 19.5 6H4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayersBehind;
